import React from "react"

const InstagramIcon = ({ title, ...props }) => (
  <img
    src="https://mindbodygreen-res.cloudinary.com/image/upload/c_scale,w_20,h_20,q_90,fl_lossy,f_auto/icons/social/instagram-logo-v2.png"
    width="20"
    height="20"
    alt="instagram-icon"
    {...(title && {
      title,
      alt: title,
    })}
    {...props}
  />
)

export default InstagramIcon
